<template>
  <div style="padding:10px;">
    <EditForm
      ref="editForm"
      :disabled="disabled"
      :amzFirstDemandCode="amzFirstDemandCode"
      :pageType="pageType"
    />
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
export default {
  name: 'ecom-awsBiz-skuFirstOrder-detail',
  components: { EditForm },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return ['detail', 'submit', 'review'].includes(this.pageType)
    },
    amzFirstDemandCode() {
      return this.params.amzFirstDemandCode
    },
  },
}
</script>
